import {
  EnvelopeIcon,
  InformationCircleIcon,
  MinusIcon,
  PencilIcon,
  PhoneIcon,
} from '@heroicons/react/24/outline'

const statusDefaults = {
  form: true,
  filter: true,
}

export const STATUSES = {
  'Pending': {
    ...statusDefaults,
    color: 'orange.400',
    _dark: { color: 'orange.500' },
    type: 'active',
  },
  'In Progress': {
    ...statusDefaults,
    color: 'purple.600',
    _dark: { color: 'purple.500' },
    type: 'active',
  },
  'On Hold - Agency': {
    ...statusDefaults,
    color: 'teal.500',
    type: 'active',
  },
  'On Hold - Constituent': {
    ...statusDefaults,
    color: 'teal.500',
    type: 'active',
  },
  'Closed': {
    ...statusDefaults,
    color: 'gray.700',
    type: 'inactive',
  },
  'Admin Closed': {
    ...statusDefaults,
    color: 'gray.700',
    type: 'inactive',
    form: false,
  },
  'Archived': {
    color: 'gray.500',
    type: 'system',
    form: false,
    filter: false,
  },
  'New Transfer': {
    ...statusDefaults,
    color: 'green.500',
    type: 'active',
    form: false,
  },
  'Transferred': {
    ...statusDefaults,
    color: 'gray.500',
    type: 'system',
    form: false,
  },
}

const _getStatusOptions = (field, value) => {
  return Object.entries(STATUSES)
    .filter(([, status]) => status[field] === value)
    .map(([name]) => name)
}

export const activeStatuses = _getStatusOptions('type', 'active')

export const inactiveStatuses = _getStatusOptions('type', 'inactive')

export const systemStatuses = _getStatusOptions('type', 'system')

export const filterableStatuses = _getStatusOptions('filter', true)

export const formSelectableStatuses = _getStatusOptions('form', true)

export const nonEditableStatuses = [...inactiveStatuses, ...systemStatuses]

export const priorityIndicatorColors = {
  'Low': {
    bgColor: 'yellow.300',
  },
  'Medium': {
    bgColor: 'orange.400',
  },
  'High': {
    bgColor: 'red.600',
    _dark: {
      bgColor: 'red.500',
    },
  },
}

export const priorityColorSchemes = {
  'Low': 'yellow',
  'Medium': 'orange',
  'High': 'red',
}

export const activityCategoryIcons = {
  'Internal': InformationCircleIcon,
  'Call': PhoneIcon,
  'Email': EnvelopeIcon,
  'Miscellaneous': MinusIcon,
  'Note': PencilIcon,
}
